import * as types from "../constants/actionTypes";

export function receivednewlyCreatedCargo(data) {
    return {
        type: types.NEWLYCREATED_NEW_CARGO,
        payload: data
    };
}

export function destroyingnewlyCreatedCargo() {
    return {
        type: types.NEWLYCREATED_CLOSE_CARGO,
    };
}



export function receivednewlyCreatedCargoPort(data) {
    return {
        type: types.NEWLYCREATED_NEW_CARGO_PORT,
        payload: data
    };
}

export function destroyingnewlyCreatedCargoPort() {
    return {
        type: types.NEWLYCREATED_CLOSE_CARGO_PORT,
    };
}



export function receivednewlyCreatedClient(data) {
    return {
        type: types.NEWLYCREATED_NEW_CLIENT,
        payload: data
    };
}

export function destroyingnewlyCreatedClient() {
    return {
        type: types.NEWLYCREATED_CLOSE_CLIENT,
    };
}



export function receivednewlyCreatedClientContact(data) {
    return {
        type: types.NEWLYCREATED_NEW_CLIENT_CONTACT,
        payload: data
    };
}

export function destroyingnewlyCreatedClientContact() {
    return {
        type: types.NEWLYCREATED_CLOSE_CLIENT_CONTACT,
    };
}



export function receivednewlyCreatedClientRate(data) {
    return {
        type: types.NEWLYCREATED_NEW_CLIENT_RATE,
        payload: data
    };
}

export function destroyingnewlyCreatedClientRate() {
    return {
        type: types.NEWLYCREATED_CLOSE_CLIENT_RATE,
    };
}



export function receivednewlyCreatedCommodity(data) {
    return {
        type: types.NEWLYCREATED_NEW_COMMODITY,
        payload: data
    };
}

export function destroyingnewlyCreatedCommodity() {
    return {
        type: types.NEWLYCREATED_CLOSE_COMMODITY,
    };
}


export function receivednewlyCreatedCommodityGroup(data) {
    return {
        type: types.NEWLYCREATED_NEW_COMMODITY_GROUP,
        payload: data
    };
}

export function destroyingnewlyCreatedCommodityGroup() {
    return {
        type: types.NEWLYCREATED_CLOSE_COMMODITY_GROUP,
    };
}



export function receivednewlyCreatedCompany(data) {
    return {
        type: types.NEWLYCREATED_NEW_COMPANY,
        payload: data
    };
}

export function destroyingnewlyCreatedCompany() {
    return {
        type: types.NEWLYCREATED_CLOSE_COMPANY,
    };
}



export function receivednewlyCreatedCompanyContact(data) {
    return {
        type: types.NEWLYCREATED_NEW_COMPANY_CONTACT,
        payload: data
    };
}

export function destroyingnewlyCreatedCompanyContact() {
    return {
        type: types.NEWLYCREATED_CLOSE_COMPANY_CONTACT,
    };
}



export function receivednewlyCreatedCost(data) {
    return {
        type: types.NEWLYCREATED_NEW_COST,
        payload: data
    };
}

export function destroyingnewlyCreatedCost() {
    return {
        type: types.NEWLYCREATED_CLOSE_COST,
    };
}



export function receivednewlyCreatedCountry(data) {
    return {
        type: types.NEWLYCREATED_NEW_COUNTRY,
        payload: data
    };
}

export function destroyingnewlyCreatedCountry() {
    return {
        type: types.NEWLYCREATED_CLOSE_COUNTRY,
    };
}



export function receivednewlyCreatedCurrency(data) {
    return {
        type: types.NEWLYCREATED_NEW_CURRENCY,
        payload: data
    };
}

export function destroyingnewlyCreatedCurrency() {
    return {
        type: types.NEWLYCREATED_CLOSE_CURRENCY,
    };
}



export function receivednewlyCreatedFog(data) {
    return {
        type: types.NEWLYCREATED_NEW_FOG,
        payload: data
    };
}

export function destroyingnewlyCreatedFog() {
    return {
        type: types.NEWLYCREATED_CLOSE_FOG,
    };
}



export function receivednewlyCreatedInvoice(data) {
    return {
        type: types.NEWLYCREATED_NEW_INVOICE,
        payload: data
    };
}

export function destroyingnewlyCreatedInvoice() {
    return {
        type: types.NEWLYCREATED_CLOSE_INVOICE,
    };
}



export function receivednewlyCreatedPort(data) {
    return {
        type: types.NEWLYCREATED_NEW_PORT,
        payload: data
    };
}

export function destroyingnewlyCreatedPort() {
    return {
        type: types.NEWLYCREATED_CLOSE_PORT,
    };
}



export function receivednewlyCreatedUnderwriter(data) {
    return {
        type: types.NEWLYCREATED_NEW_UNDERWRITER,
        payload: data
    };
}

export function destroyingnewlyCreatedUnderwriter() {
    return {
        type: types.NEWLYCREATED_CLOSE_UNDERWRITER,
    };
}



export function receivednewlyCreatedUnderwriterRate(data) {
    return {
        type: types.NEWLYCREATED_NEW_UNDERWRITER_RATE,
        payload: data
    };
}

export function destroyingnewlyCreatedUnderwriterRate() {
    return {
        type: types.NEWLYCREATED_CLOSE_UNDERWRITER_RATE,
    };
}



export function receivednewlyCreatedVessel(data) {
    return {
        type: types.NEWLYCREATED_NEW_VESSEL,
        payload: data
    };
}

export function destroyingnewlyCreatedVessel() {
    return {
        type: types.NEWLYCREATED_CLOSE_VESSEL,
    };
}


// WEBPACK FOOTER //
// ./src/actions/creation.js